'use strict';

class Calculator {
    
    constructor() {
        this.type = window.AMAtype;

        this.form = null;
        this.formSlider = null;
        this.formSliderBubble = null;
        this.formSliderInput = null;
        this.formSliderInputDisplayed = null;
        this.formSliderMaxLabel = null;
        this.resultRegularWhole = null;
        this.resultRegularFraction = null;
        this.resultDiscountWhole = null;
        this.resultDiscountFraction = null;
        this.resultTotalWhole = null;
        this.resultTotalFraction = null;
        this.buttonFormSend = null;
        this.buttonFormApply = null;
        this.modalEmailResult = null;
        this.wrapperActions = null;
        this.wrapperResults = null;

        this.sliderChangeCount = 0; // need to differentiate between initial slider move and manual move

        this.rates = {
            TermLife: {
                unitSize: 50000,
                // Monthly rates per $50,000 units of coverage
                regular: {
                    'male' : {
                        'nonsmoker' : [1.17, 1.29, 1.51, 1.97, 2.60, 3.71, 5.59, 10.17, 18.76, 28.57, 59.90],
                        'smoker'    : [2.05, 2.31, 3.43, 5.64, 7.86, 9.77, 21.14, 30.12, 39.70, 50.26, 105.54]
                    },
                    'female' : {
                        'nonsmoker' : [0.62, 0.73, 1.24, 1.46, 1.97, 2.41, 4.13, 6.96, 12.74, 13.53, 29.92],
                        'smoker'    : [1.06, 1.26, 2.51, 3.83, 5.15, 6.87, 14.34, 19.02, 29.46, 31.44, 69.42]
                    }
                },
                discount: 0,
                applicationPDF: '/assets/pdf/ama-termlife-insurance-application.pdf',
                wsURL: 'https://amacampaign2020.azurewebsites.net/api/Calculate?code=hIOzCzW7povak6HvmYX/eJbcbLiB276KcWeG8c7i861oLXtSWvur2w=='
            },

            CriticalIllness: {
                unitSize: 10000,
                // monthly rates per $10,000 units of coverage (rates for <25 and <30 are the same)
                regular: {
                    'male' : {
                        'nonsmoker' : [0.96, 0.96, 1.34, 1.62, 2.37, 4.06, 6.59, 10.43, 17.16, 29.69, 48.03],
                        'smoker'    : [1.24, 1.24, 1.88, 2.49, 4.39, 8.66, 16.27, 26.89, 43.18, 66.23, 117.31]
                    },
                    'female' : {
                        'nonsmoker' : [0.91, 0.91, 1.70, 2.13, 2.90, 4.21, 5.63, 7.58, 10.74, 17.57, 25.89],
                        'smoker'    : [1.10, 1.10, 2.31, 3.42, 5.50, 8.78, 12.28, 16.00, 20.57, 29.15, 41.79]
                    }
                },
                discount: null,
                applicationPDF: '/assets/pdf/ama-criticalillness-insurance-application.pdf',
                wsURL: 'https://criticalillnes2020.azurewebsites.net/api/Calculate?code=Fiz9LJSZn89wQl/dExaKGSEc5kqJTN2AaEhljao/ZuXitAP5c93kIg=='
            },

            // !!! Disability calculation is DIFFERENT from TermLife and CriticalIllness. Age groups are DIFFERENT as well !!!
            Disability: {
                unitSize: 100,
                // Monthly Rates per $100 of benefit
                regular: {
                    'male' : {
                        'nonsmoker' : {
                            '30' : [1.1464, 1.8230, 2.1664, 2.5479, 3.1774, 3.6306, 4.2047, 2.4961],
                            '60' : [0.9175, 1.4579, 1.7331, 2.0383, 2.5416, 2.9049, 3.3635, 2.1219],
                            '90' : [0.5976, 0.8647, 1.3507, 1.5824, 2.1236, 2.3980, 2.7422, 1.8857],
                            '120' : [0.5431, 0.7867, 1.2271, 1.4379, 1.9302, 2.1800, 2.4934, 1.8222]
                        },
                        'smoker' : {
                            '30' : [1.6614, 2.6433, 3.1392, 3.6932, 4.6044, 5.2628, 6.0931, 3.6179],
                            '60' : [1.3289, 2.1146, 2.5116, 2.9548, 3.6833, 4.2101, 4.8742, 3.0757],
                            '90' : [0.9175, 1.3271, 2.0719, 2.4280, 3.2591, 3.6796, 4.2083, 2.8940],
                            '120' : [0.8339, 1.2063, 1.8838, 2.2073, 2.9629, 3.3454, 3.8259, 2.7959]
                        }
                    },
                    'female' : {
                        'nonsmoker' : {
                            '30' : [2.2209, 3.5316, 4.1938, 4.9358, 5.4091, 5.6798, 6.2639, 3.7196],
                            '60' : [1.7767, 2.8250, 3.3545, 3.9485, 4.3282, 4.5434, 5.0113, 3.1619],
                            '90' : [1.2263, 1.7740, 2.4961, 2.7686, 3.7823, 4.0202, 4.3273, 2.9757],
                            '120' : [1.1200, 1.6195, 2.2790, 2.5269, 3.4534, 3.6714, 3.9504, 2.8866]
                        },
                        'smoker' : {
                            '30' : [2.6646, 4.2380, 5.0344, 5.9230, 6.4921, 6.8169, 7.5167, 4.4631],
                            '60' : [2.1319, 3.3902, 4.0280, 4.7386, 5.1941, 5.4535, 6.0130, 3.7943],
                            '90' : [1.4705, 2.1287, 3.3226, 3.8940, 4.5392, 4.8243, 5.1920, 3.5703],
                            '120' : [1.3430, 1.9433, 3.0343, 3.5553, 4.1448, 4.4052, 4.7407, 3.4641]
                        }
                    }
                },
                discount: 0,
                applicationPDF: '/assets/pdf/ama-disability-insurance-application.pdf',
                wsURL: 'https://amadisability2020.azurewebsites.net/api/Calculate?code=Ixc2kM2gE/8W1E7ochqD7GuS/hKOdFbLctp8XjopQpBYstqA24ZC9Q==',
                incomeBenefit: [{"MinIncome":60000,"MaxIncome":62499,"Benefit":3500},{"MinIncome":62500,"MaxIncome":64999,"Benefit":3600},{"MinIncome":65000,"MaxIncome":68332,"Benefit":3800},{"MinIncome":68333,"MaxIncome":69999,"Benefit":3900},{"MinIncome":70000,"MaxIncome":72499,"Benefit":4000},{"MinIncome":72500,"MaxIncome":74999,"Benefit":4100},{"MinIncome":75000,"MaxIncome":77499,"Benefit":4200},{"MinIncome":77500,"MaxIncome":79999,"Benefit":4300},{"MinIncome":80000,"MaxIncome":82499,"Benefit":4400},{"MinIncome":82500,"MaxIncome":84999,"Benefit":4500},{"MinIncome":85000,"MaxIncome":87499,"Benefit":4600},{"MinIncome":87500,"MaxIncome":89999,"Benefit":4700},{"MinIncome":90000,"MaxIncome":96999,"Benefit":5000},{"MinIncome":97000,"MaxIncome":99999,"Benefit":5100},{"MinIncome":100000,"MaxIncome":104999,"Benefit":5200},{"MinIncome":105000,"MaxIncome":107499,"Benefit":5300},{"MinIncome":107500,"MaxIncome":109999,"Benefit":5400},{"MinIncome":110000,"MaxIncome":116999,"Benefit":5600},{"MinIncome":117000,"MaxIncome":119999,"Benefit":5700},{"MinIncome":120000,"MaxIncome":127499,"Benefit":6000},{"MinIncome":127500,"MaxIncome":129999,"Benefit":6100},{"MinIncome":130000,"MaxIncome":136999,"Benefit":6300},{"MinIncome":137000,"MaxIncome":139999,"Benefit":6500},{"MinIncome":140000,"MaxIncome":149999,"Benefit":6900},{"MinIncome":150000,"MaxIncome":159999,"Benefit":7300},{"MinIncome":160000,"MaxIncome":171249,"Benefit":7500},{"MinIncome":171250,"MaxIncome":180999,"Benefit":7600},{"MinIncome":181000,"MaxIncome":189999,"Benefit":8000},{"MinIncome":190000,"MaxIncome":201499,"Benefit":8300},{"MinIncome":201500,"MaxIncome":212499,"Benefit":8600},{"MinIncome":212500,"MaxIncome":219999,"Benefit":8900},{"MinIncome":220000,"MaxIncome":231249,"Benefit":9200},{"MinIncome":231250,"MaxIncome":239999,"Benefit":9500},{"MinIncome":240000,"MaxIncome":249999,"Benefit":9700},{"MinIncome":250000,"MaxIncome":261249,"Benefit":10000},{"MinIncome":261250,"MaxIncome":272499,"Benefit":10300},{"MinIncome":272500,"MaxIncome":279999,"Benefit":10600},{"MinIncome":280000,"MaxIncome":289999,"Benefit":10900},{"MinIncome":290000,"MaxIncome":299999,"Benefit":11100},{"MinIncome":300000,"MaxIncome":309999,"Benefit":11400},{"MinIncome":310000,"MaxIncome":321249,"Benefit":11600},{"MinIncome":321250,"MaxIncome":332499,"Benefit":11900},{"MinIncome":332500,"MaxIncome":339999,"Benefit":12100},{"MinIncome":340000,"MaxIncome":349999,"Benefit":12400},{"MinIncome":350000,"MaxIncome":359999,"Benefit":12600},{"MinIncome":360000,"MaxIncome":369999,"Benefit":12900},{"MinIncome":370000,"MaxIncome":379999,"Benefit":13100},{"MinIncome":380000,"MaxIncome":392499,"Benefit":13300},{"MinIncome":392500,"MaxIncome":399999,"Benefit":13500},{"MinIncome":400000,"MaxIncome":409999,"Benefit":13700},{"MinIncome":410000,"MaxIncome":419999,"Benefit":14000},{"MinIncome":420000,"MaxIncome":429999,"Benefit":14200},{"MinIncome":430000,"MaxIncome":439999,"Benefit":14500},{"MinIncome":440000,"MaxIncome":449999,"Benefit":14700},{"MinIncome":450000,"MaxIncome":459999,"Benefit":14900},{"MinIncome":460000,"MaxIncome":469999,"Benefit":15200},{"MinIncome":470000,"MaxIncome":479999,"Benefit":15400},{"MinIncome":480000,"MaxIncome":489999,"Benefit":15700},{"MinIncome":490000,"MaxIncome":499999,"Benefit":15900},{"MinIncome":500000,"MaxIncome":509999,"Benefit":16100},{"MinIncome":510000,"MaxIncome":519999,"Benefit":16400},{"MinIncome":520000,"MaxIncome":529999,"Benefit":16600},{"MinIncome":530000,"MaxIncome":539999,"Benefit":16900},{"MinIncome":540000,"MaxIncome":553299,"Benefit":17100},{"MinIncome":553300,"MaxIncome":559999,"Benefit":17400},{"MinIncome":560000,"MaxIncome":569999,"Benefit":17600},{"MinIncome":570000,"MaxIncome":579999,"Benefit":17800},{"MinIncome":580000,"MaxIncome":589999,"Benefit":18100},{"MinIncome":590000,"MaxIncome":599999,"Benefit":18300},{"MinIncome":600000,"MaxIncome":609999,"Benefit":18600},{"MinIncome":610000,"MaxIncome":619999,"Benefit":18900},{"MinIncome":620000,"MaxIncome":629999,"Benefit":19000},{"MinIncome":630000,"MaxIncome":639999,"Benefit":19300},{"MinIncome":640000,"MaxIncome":649999,"Benefit":19500},{"MinIncome":650000,"MaxIncome":659999,"Benefit":19700},{"MinIncome":660000,"MaxIncome":669999,"Benefit":20000},{"MinIncome":670000,"MaxIncome":679999,"Benefit":20200},{"MinIncome":680000,"MaxIncome":689999,"Benefit":20400},{"MinIncome":690000,"MaxIncome":699999,"Benefit":20700},{"MinIncome":700000,"MaxIncome":709999,"Benefit":20900},{"MinIncome":710000,"MaxIncome":719999,"Benefit":21100},{"MinIncome":720000,"MaxIncome":729999,"Benefit":21300},{"MinIncome":730000,"MaxIncome":739999,"Benefit":21600},{"MinIncome":740000,"MaxIncome":749999,"Benefit":21800},{"MinIncome":750000,"MaxIncome":759999,"Benefit":22000},{"MinIncome":760000,"MaxIncome":769999,"Benefit":22300},{"MinIncome":770000,"MaxIncome":779999,"Benefit":22500},{"MinIncome":780000,"MaxIncome":789999,"Benefit":22700},{"MinIncome":790000,"MaxIncome":799999,"Benefit":22900},{"MinIncome":800000,"MaxIncome":809999,"Benefit":23100},{"MinIncome":810000,"MaxIncome":819999,"Benefit":23300},{"MinIncome":820000,"MaxIncome":829999,"Benefit":23600},{"MinIncome":830000,"MaxIncome":839999,"Benefit":23700},{"MinIncome":840000,"MaxIncome":849999,"Benefit":24000},{"MinIncome":850000,"MaxIncome":859999,"Benefit":24100},{"MinIncome":860000,"MaxIncome":869999,"Benefit":24400},{"MinIncome":870000,"MaxIncome":879999,"Benefit":24600},{"MinIncome":880000,"MaxIncome":889999,"Benefit":24800},{"MinIncome":890000,"MaxIncome":949999,"Benefit":25000},{"MinIncome":950000,"MaxIncome":999999,"Benefit":26000},{"MinIncome":1000000,"MaxIncome":1099999,"Benefit":27000},{"MinIncome":1100000,"MaxIncome":1199.999,"Benefit":28500},{"MinIncome":1200000,"MaxIncome":1299999,"Benefit":29800},{"MinIncome":1300000,"MaxIncome":1399999,"Benefit":30800},{"MinIncome":1400000,"MaxIncome":1499999,"Benefit":32000},{"MinIncome":1500000,"MaxIncome":1500000,"Benefit":33000}]
            }
        }
    }

    init() {
        this.form = document.getElementById('formCalculator');
        this.formSlider = document.getElementById('calculatorCoverageSlider');
        this.formSliderBubble = document.getElementById('calculatorCoverageSliderBubble');
        this.formSliderInput = document.getElementById('calculatorCoverage');
        this.formSliderInputDisplayed = document.getElementById('calculatorCoverageDisplayed');
        this.formSliderMaxLabel = document.querySelector('.tps-calculator__form__slider__label--max');
        this.resultRegularWhole = document.getElementById('calculatorResultRegularWhole');
        this.resultRegularFraction = document.getElementById('calculatorResultRegularFraction');
        this.resultDiscountWhole = document.getElementById('calculatorResultDiscountWhole');
        this.resultDiscountFraction = document.getElementById('calculatorResultDiscountFraction');
        this.resultTotalWhole = document.getElementById('calculatorResultTotalWhole');
        this.resultTotalFraction = document.getElementById('calculatorResultTotalFraction');
        this.buttonFormSend = document.getElementById('buttonFormSend');
        this.buttonFormApply = document.getElementById('buttonFormApply');
        this.modalEmailResult = document.getElementById('modalEmailResult');
        this.wrapperActions = document.querySelector('.tps-calculator__form__actions');
        this.wrapperResults = document.querySelector('.tps-calculator__form__results');

        if (this.form) {
            this.onFormSubmit();
            this.onFormInputsChange();
            this.onFormSendClick();
            this.onFormApplyClick();
        }
    }

    onFormSubmit() {
        const self = this;
        self.form.addEventListener('submit', function(e) {
            e.preventDefault();
        });
    }

    onFormSendClick() {
        const self = this;
        self.buttonFormSend.addEventListener('click', function(e) {
            if (self.form.reportValidity()) {
                self.sendToService(true);
            }
        });
    }

    onFormApplyClick() {
        const self = this;

        self.buttonFormApply.addEventListener('click', function(e) {
            window.open(self.rates[self.type].applicationPDF);
        });
    }

    onFormInputsChange() {
        const self = this;

        const currencyFormatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        });

        const formSex = Array.prototype.slice.call(self.form.elements.sex);
        const formDoesSmoke = Array.prototype.slice.call(self.form.elements.doesSmoke);

        formSex.forEach(function(element) {
            element.addEventListener('change', function() {
                self.refreshRates();
            });
        });

        formDoesSmoke.forEach(function(element) {
            element.addEventListener('change', function() {
                self.refreshRates();
            });
        });

        self.form.elements.age.addEventListener('change', function() {
            self.refreshRates();
        });

        if (self.form.elements.annualEarnedIncome) {
            const message = document.querySelector('[data-message-for="' + self.form.elements.annualEarnedIncome.id + '"]');
            const min = parseInt(self.form.elements.annualEarnedIncome.dataset.min, 10);
            const max = parseInt(self.form.elements.annualEarnedIncome.dataset.max, 10);
            
            jQuery(self.form.elements.annualEarnedIncome).on('change blur', function() {
                let digitValue = self.form.elements.annualEarnedIncome.value.replace(/\D/g, '');

                if (digitValue === '') {
                    self.disableCoverageCalculation();
                    return;
                } else {
                    self.enableCoverageCalculation();
                }

                // automatically change if value is not within min and max
                if (digitValue < min) {
                    digitValue = min;
                    message.classList.remove('hide');
                } else if (digitValue > max) {
                    digitValue = max;
                    message.classList.remove('hide');
                } else {
                    message.classList.add('hide');
                }
                self.form.elements.annualEarnedIncome.value = currencyFormatter.format(digitValue).substring(1);

                // change maximum coverage amount based on Annual Earned Income (for Disability)
                const coverage = self.rates[self.type].incomeBenefit
                    .find(val => digitValue >= val.MinIncome && digitValue <= val.MaxIncome)
                    .Benefit;

                const slider = jQuery(self.formSlider);
                const start = slider.data('zfPlugin').options.start;

                slider.data('zfPlugin').options.end = coverage;
                slider.data('zfPlugin').options.initialStart = ((coverage - start) / 2 ) + start; // land in the middle
                slider.data('zfPlugin')._setInitAttr(0);
                slider.foundation('setHandles');
                self.formSliderMaxLabel.innerHTML = '<sup>$</sup>' + currencyFormatter.format(coverage).replace('$','');
            });

            // formatting the displayed coverage input value to include commas
            self.form.elements.annualEarnedIncome.addEventListener('keyup', function(e) {
                let digitValue = self.form.elements.annualEarnedIncome.value.replace(/\D/g, '');
                self.form.elements.annualEarnedIncome.value = currencyFormatter.format(digitValue).substring(1);
            });
        }

        if (self.form.elements.eliminationPeriod) {
            self.form.elements.eliminationPeriod.addEventListener('change', function() {
                self.refreshRates();
            });
        }

        // formatting the displayed coverage input value to include commas
        self.formSliderInputDisplayed.addEventListener('keyup', function(e) {
            let digitValue = self.formSliderInputDisplayed.value.replace(/\D/g, '');
            self.formSliderInputDisplayed.value = currencyFormatter.format(digitValue).substring(1);
        });

        // if the "visual" input's value is changed, change the Foundation's slider's hidden input and call change
        jQuery(self.formSliderInputDisplayed).on('change blur', function(e) {
            const slider = jQuery(self.formSlider);
            
            let digitValue = self.formSliderInputDisplayed.value.replace(/\D/g, '');
            let adjustedValue = slider.data('zfPlugin')._adjustValue(null, digitValue);

            self.formSliderInput.value = adjustedValue;
            slider.foundation('setHandles');
        });

        // Every move
        jQuery(self.formSlider).on('moved.zf.slider', function() {
            if (!self.formSliderInput.value) self.formSliderInput.value = 200000;

            self.formSliderInputDisplayed.value = currencyFormatter.format(self.formSliderInput.value).substring(1);

            self.formSliderBubble.innerHTML = currencyFormatter.format(self.formSliderInput.value);
            self.refreshRates();
        });

        // Change after moving
        jQuery(self.formSlider).on('changed.zf.slider', function() {
            self.sliderChangeCount++;
            if (self.sliderChangeCount > 1) {
                self.sendToService(false);
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ 
                    'event': 'coverage_changed',
                    'coverageValue': self.formSliderInput.value
                });
            }
        });
    }

    refreshRates() {
        const self = this;

        const sex = document.querySelector('input[name=sex]:checked').value;
        const doesSmoke = document.querySelector('input[name=doesSmoke]:checked').value === 'true';
        const age = self.form.elements.age.value;
        const coverage = self.formSliderInput.value; 
        const eliminationPeriod = self.form.elements.eliminationPeriod ? self.form.elements.eliminationPeriod.value : null;

        const rates = self.calculateRates(sex, doesSmoke, age, coverage, eliminationPeriod);

        const regularPrice = rates.regularPrice.toFixed(2).split('.');

        if (rates.discount && rates.discountedPrice) {
            let discount = rates.discount.toFixed(2).split('.');
            let totalPrice = rates.discountedPrice.toFixed(2).split('.');

            self.resultRegularWhole.innerHTML = regularPrice[0];
            self.resultRegularFraction.innerHTML = '.' + regularPrice[1];
            self.resultDiscountWhole.innerHTML = discount[0];
            self.resultDiscountFraction.innerHTML = '.' + discount[1];
            self.resultTotalWhole.innerHTML = totalPrice[0];
            self.resultTotalFraction.innerHTML = '.' + totalPrice[1];
        } else {
            // total equals regular price
            self.resultTotalWhole.innerHTML = regularPrice[0];
            self.resultTotalFraction.innerHTML = '.' + regularPrice[1];
        }
    }

    calculateRates(sex, isSmoker, age, coverage, eliminationPeriod) {
        const self = this;
        
        let ageInterval = self.getAgeInterval(parseInt(age, 10));
        let smokerStatus = isSmoker ? 'smoker' : 'nonsmoker';

        // based on type
        let units = parseInt(coverage, 10) / self.rates[self.type].unitSize; 
        let regularPrice = eliminationPeriod ? self.rates[self.type].regular[sex][smokerStatus][eliminationPeriod][ageInterval] * units : self.rates[self.type].regular[sex][smokerStatus][ageInterval] * units;
        let discount = self.rates[self.type].discount ? regularPrice * self.rates[self.type].discount : null;
        let discountedPrice = discount ? regularPrice - discount : null;
        
        return {
            regularPrice: regularPrice,
            discountedPrice: discountedPrice,
            discount: discount
        };
    }

    getAgeInterval(age) {
        const self = this;

        if (self.type === 'TermLife' || self.type === 'CriticalIllness') {
            if (age < 25) {
                return 0;
            } else if (age < 30) {
                return 1;
            } else if (age < 35) {
                return 2;
            } else if (age < 40) {
                return 3;
            } else if (age < 45) {
                return 4;
            } else if (age < 50) {
                return 5;
            } else if (age < 55) {
                return 6;
            } else if (age < 60) {
                return 7;
            } else if (age < 65) {
                return 8;
            } else if (age < 70) {
                return 9;
            } else if (age < 75) {
                return 10;
            } 
        } else {
            if (age < 35) {
                return 0;
            } else if (age < 40) {
                return 1;
            } else if (age < 45) {
                return 2;
            } else if (age < 50) {
                return 3;
            } else if (age < 55) {
                return 4;
            } else if (age < 60) {
                return 5;
            } else if (age < 65) {
                return 6;
            } else if (age < 70) {
                return 7;
            }
        }
    }

    sendToService(isEmail) {
        const self = this;

        const url = self.rates[self.type].wsURL;
        const age = parseInt(self.form.elements.age.value, 10);
        const sex = self.form.elements.sex.value;
        const doesSmoke = self.form.elements.doesSmoke.value === 'true';
        const coverage = parseInt(self.formSliderInput.value, 10); 
        const email = isEmail ? self.form.elements.email.value : '';

        const data = {
            'age' : age,
            'sex' : sex,
            'is_smoker' : doesSmoke,
            'coverage_amount' : coverage,
            'email' : email
        };

        if (self.type === 'Disability') {
            if (self.form.elements.eliminationPeriod.value === '' && self.form.elements.annualEarnedIncome.value === '') {
                return;
            }
            data.period = parseInt(self.form.elements.eliminationPeriod.value, 10);
            data.income = parseInt(self.form.elements.annualEarnedIncome.value.replace(/\D/g, ''), 10);
        } 

        jQuery.ajax({
            url: url,
            type: 'POST',
            data: JSON.stringify(data),
            dataType: 'JSON',
            beforeSend: function() {
                self.buttonFormSend.setAttribute('disabled', 'disabled');
            }
        }).done(function(response) {
            if (isEmail) {
                jQuery(modalEmailResult).foundation('toggle');
                TPS.popups.hideAllPopups();
            }
        }).fail(function(response) {
            console.log(response);
            if (isEmail) alert('Error! Please try again.');
        }).always(function() {
            self.buttonFormSend.removeAttribute('disabled');
        });
    }

    enableCoverageCalculation() {
        const self = this;

        self.formSlider.classList.remove('disabled');
        self.formSliderMaxLabel.classList.remove('hide');
        self.formSliderBubble.classList.remove('hide');
        self.formSliderInputDisplayed.removeAttribute('disabled');
        self.wrapperResults.classList.remove('hide');
        self.wrapperActions.classList.remove('hide');
    }

    disableCoverageCalculation() {
        const self = this;

        self.formSlider.classList.add('disabled');
        self.formSliderMaxLabel.classList.add('hide');
        self.formSliderBubble.classList.add('hide');
        self.formSliderInputDisplayed.setAttribute('disabled', 'disabled');
        self.wrapperResults.classList.add('hide');
        self.wrapperActions.classList.add('hide');
    }
}